import { createGetRequest, createPostRequest, createPostRequest2 } from '.';

// 동영상 url 가져오기 => http://voddev-api.jei.com/VOD/QR/KE/B/B17/01/KE_B_B17_01_000053
export const getVodURL = ({param1}) => createGetRequest(`/VOD${param1}`);
// 로그 남기기 => http://voddev-api.jei.com/log
export const postLog = (payload) => createPostRequest(`/log`, payload); 
//관리자 화면 - 영상 배포 -> https://devtranscoding-api.jei.com/deploy/E/test_a11bc_0227.mp4/p2021A008
export const postDeploy = ({param1, param2, param3, param4}) => createPostRequest2(`/deploy/${param1}/${param2}/${param3}/${param4}`);
//관리자 화면 - 동영상 url 가져오기 -> router.get('/admin/:gubun/:vodcode', vodController.getVodUrl)
export const getAdminVodURL = ({param1, param2}) => createGetRequest(`/admin/${param1}/${param2}`);
